export const SET_MFA_METHODS = 'SET_MFA_METHODS';
export const SET_MFA_SETTINGS = 'SET_MFA_SETTINGS';
export const ON_METHOD_STATUS_CHANGE = 'ON_METHOD_STATUS_CHANGE';